module.exports = __webpack_public_path__ + "static/calatonStudioBrandingDesktop@2x-2bf514656af8a37a54b242a3b6688070.jpg";